import { render, staticRenderFns } from "./LivestreamAssignRole.vue?vue&type=template&id=61d6dfb4&scoped=true"
import script from "./LivestreamAssignRole.vue?vue&type=script&lang=js"
export * from "./LivestreamAssignRole.vue?vue&type=script&lang=js"
import style0 from "./LivestreamAssignRole.vue?vue&type=style&index=0&id=61d6dfb4&prod&scoped=true&lang=scss"
import style1 from "./LivestreamAssignRole.vue?vue&type=style&index=1&id=61d6dfb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d6dfb4",
  null
  
)

export default component.exports